
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { computed, Ref, watch } from 'vue';
import { UserInformation } from '@/types/user-data';
import { RouteNames } from '@/router';
import type { Client } from 'altru-types';

export default {
  name: 'Landing',
  components: {},
  setup(): { t: (key: string, keys?: string[]) => string } {
    const { t } = useI18n();
    const { getters } = useStore();
    const { replace } = useRouter();
    const isLoading: Ref<boolean> = computed(() => getters['ui/isLoading']);
    const userInformationNeeded: Ref<boolean> = computed(() => getters['clients/userInformationNeeded']);
    const userInformationCollected: Ref<UserInformation | null> = computed(
      () => getters['users/userInformationCollected'],
    );
    const client: Ref<Client | null> = computed(() => getters['clients/workspaceInfo']);
    const clickWrapFeatureEnabled: Ref<boolean> = computed(
      () => client.value?.feature_keys?.includes('click_wrap_terms_and_conditions') ?? false,
    );
    const isIframed: Ref<boolean> = computed(() => getters['status/isIframed']);

    watch(
      () => isLoading.value,
      (loadingStatus) => {
        if (!loadingStatus) {
          const needsUserInput = userInformationNeeded.value && !userInformationCollected.value;

          if (!isIframed.value) {
            if (needsUserInput) {
              return replace({ name: RouteNames.UserData });
            } else {
              if (clickWrapFeatureEnabled.value) {
                return replace({ name: RouteNames.Terms });
              }
              return replace({ name: RouteNames.Camera });
            }
          } else {
            return replace({ name: RouteNames.Camera });
          }
        }
      },
    );

    return {
      t,
    };
  },
};
